// ** Icon imports
import HomeIcon from 'mdi-material-ui/Home'
import TaskIcon from '@mui/icons-material/Task'
import LockIcon from '@mui/icons-material/Lock'
import FormatQuoteIcon from '@mui/icons-material/FormatQuote'
import ContactPageIcon from '@mui/icons-material/ContactPage'
import HelpIcon from '@mui/icons-material/Help'
import PlaceIcon from '@mui/icons-material/Place'
import Diversity3Icon from '@mui/icons-material/Diversity3'
import LocationCityIcon from '@mui/icons-material/LocationCity'
import PublicIcon from '@mui/icons-material/Public'
import ArticleIcon from '@mui/icons-material/Article'
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded'
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded'
import LocalOfferIcon from '@mui/icons-material/LocalOffer'
import GroupsIcon from '@mui/icons-material/Groups'
import SellOutlinedIcon from '@mui/icons-material/SellOutlined'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined'
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined'
import InventoryIcon from '@mui/icons-material/Inventory'
import ProductionQuantityLimitsOutlinedIcon from '@mui/icons-material/ProductionQuantityLimitsOutlined'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import PinDropOutlinedIcon from '@mui/icons-material/PinDropOutlined'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import LocalAtmOutlinedIcon from '@mui/icons-material/LocalAtmOutlined'
import ViewInArOutlinedIcon from '@mui/icons-material/ViewInArOutlined'
import ScaleOutlinedIcon from '@mui/icons-material/ScaleOutlined'
import CurrencyRupeeOutlinedIcon from '@mui/icons-material/CurrencyRupeeOutlined'
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined'
import LocalActivityOutlinedIcon from '@mui/icons-material/LocalActivityOutlined'
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined'
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined'
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined'
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined'
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined'
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined'
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined'
import StarOutlinedIcon from '@mui/icons-material/StarOutlined'
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined'
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined'
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined'
import NotificationsIcon from '@mui/icons-material/Notifications'
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined'
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined'
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined'
import WarehouseIcon from '@mui/icons-material/Warehouse'

const navigation = () => {
  return [
    {
      title: 'Dashboard',
      icon: HomeIcon,
      path: '/dashboard'
    },
    {
      sectionTitle: 'Website Settings'
    },
    {
      title: 'Website',
      icon: PublicIcon,
      children: [
        {
          title: 'Privacy Policy',
          icon: LockIcon,
          path: '/privacy-policy'
        },
        {
          title: 'Terms and Conditions',
          icon: TaskIcon,
          path: '/terms-conditions'
        },
        {
          title: 'Testimonials',
          icon: FormatQuoteIcon,
          path: '/testimonials'
        },
        {
          title: 'Contact Us',
          icon: ContactPageIcon,
          path: '/contact-us'
        },
        {
          title: 'FAQS',
          icon: HelpIcon,
          path: '/faqs'
        },
        {
          title: 'Blog',
          icon: ArticleIcon,
          path: '/blog'
        },
        {
          title: 'Team Members',
          icon: GroupsIcon,
          path: '/our-team'
        }
      ]
    },
    {
      sectionTitle: 'User Management'
    },
    {
      title: 'Users',
      icon: Diversity3Icon,
      children: [
        {
          title: 'Customer',
          icon: PersonOutlineIcon,
          path: '/customers'
        },
        {
          title: 'Business User',
          icon: BusinessCenterOutlinedIcon,
          path: '/business-users'
        }
      ]
    },
    {
      title: 'Sub Admin Management',
      icon: AdminPanelSettingsOutlinedIcon,
      children: [
        {
          title: 'Permissions',
          icon: LockOutlinedIcon,
          path: '/permissions'
        },
        {
          title: 'Roles',
          icon: GroupsOutlinedIcon,
          path: '/roles'
        },
        {
          title: 'Sub Admin',
          icon: PersonOutlineOutlinedIcon,
          path: '/sub-admin'
        }
      ]
    },
    {
      sectionTitle: 'Customer Feedback'
    },
    {
      title: 'Ratings',
      icon: StarOutlinedIcon,
      path: '/ratings'
    },
    {
      title: 'Notifications',
      icon: NotificationsOutlinedIcon,
      path: '/notifications'
    },
    {
      title: 'Campaign Notifications',
      icon: CampaignOutlinedIcon,
      children: [
        {
          title: 'Send Email Alert',
          icon: NotificationsIcon,
          path: '/email-notification'
        },
        { title: 'Send Push Alert', icon: NotificationsActiveOutlinedIcon, path: '/campaign-notifications' },
        { title: 'Send SMS Alert', icon: SmsOutlinedIcon, path: '/sms-alert' }
      ]
    },
    {
      sectionTitle: 'Location Management'
    },
    {
      title: 'Location',
      icon: PlaceIcon,
      children: [
        {
          title: 'City Management',
          icon: LocationCityIcon,
          path: '/city-management'
        },
        {
          title: 'Zone',
          icon: PinDropOutlinedIcon,
          path: '/zone'
        },
        {
          title: 'HQ Address',
          icon: HomeOutlinedIcon,
          path: '/hq-address'
        }
      ]
    },
    {
      sectionTitle: 'Pricing & Packages'
    },
    {
      title: 'Price Management',
      icon: LocalAtmOutlinedIcon,
      children: [
        {
          title: 'Order Service',
          icon: ReceiptLongOutlinedIcon,
          path: '/order-service'
        },
        {
          title: 'Package Dimension',
          icon: ViewInArOutlinedIcon,
          path: '/package-dimension'
        },
        {
          title: 'Package Weight',
          icon: ScaleOutlinedIcon,
          path: '/package-weight'
        }
        // {
        //   title: 'Package Opened Charges',
        //   icon: CurrencyRupeeOutlinedIcon,
        //   path: '/package-opened-charges'
        // }
      ]
    },
    {
      sectionTitle: 'Product Management'
    },
    {
      title: 'Products',
      icon: CategoryRoundedIcon,
      children: [
        {
          title: 'Product Category',
          icon: CategoryOutlinedIcon,
          path: '/product-category'
        },
        {
          title: 'Product Packaging',
          icon: LocalShippingRoundedIcon,
          path: '/product-packaging'
        }
      ]
    },
    {
      title: 'Inventory',
      icon: InventoryIcon,
      children: [
        {
          title: 'Inventory Package',
          icon: Inventory2OutlinedIcon,
          path: '/inventory-package'
        },
        {
          title: 'Package Request',
          icon: LocalShippingOutlinedIcon,
          path: '/inventory-package-request'
        },
        {
          title: 'Product Inventory Request',
          icon: ProductionQuantityLimitsOutlinedIcon,
          path: '/product-inventory-request'
        }
      ]
    },
    {
      title: 'Storage Unit',
      icon: WarehouseIcon,
      path: '/storage-units'
    },
    {
      sectionTitle: 'Orders & Payments'
    },
    {
      title: 'Orders',
      icon: ShoppingCartOutlinedIcon,
      path: '/order-status'
    },
    {
      title: 'Cashout Request',
      icon: AccountBalanceWalletOutlinedIcon,
      path: '/cashout-request'
    },
    {
      title: 'Log Issue',
      icon: ReportProblemOutlinedIcon,
      path: '/log-issues'
    },
    {
      title: 'Log Issue Reasons',
      icon: FactCheckOutlinedIcon,
      path: '/main-reasons'
    },
    {
      title: 'Coupons & Referral',
      icon: LocalActivityOutlinedIcon,
      children: [
        {
          title: 'Coupon Usage History',
          icon: LocalOfferIcon,
          path: '/coupons'
        },
        {
          title: 'Referral Code',
          icon: SellOutlinedIcon,
          path: '/referral-code'
        }
      ]
    },
    {
      title: 'Commission Amount',
      icon: SavingsOutlinedIcon,
      path: '/commission-amount'
    },
    {
      title: 'Billing & Payment',
      icon: PaymentsOutlinedIcon,
      children: [
        {
          title: 'Billing Invoice Type',
          icon: RequestQuoteOutlinedIcon,
          path: '/billing-invoice-payment'
        },
        {
          title: 'Billing Payment Management',
          icon: PaymentOutlinedIcon,
          path: '/billing-payment-management'
        }
      ]
    }
  ]
}

export default navigation
